
import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

export default function BillingAdminPage() {
  const { keycloak } = useAuth();
  const token = keycloak.token;

  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('');
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    if (!token) return;

    fetch("http://localhost:3001/admin/billing", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setSubscriptions(data))
      .catch(err => {
        console.error(err);
        setMessage("Erreur lors du chargement des abonnements.");
        setVariant("danger");
      });
  }, [token]);

  return (
    <div className="container-fluid pt-5" style={{ paddingLeft: "100px", width: "100%" }}>
      {message && (
        <div
          className={`alert alert-${variant} alert-dismissible fade show`}
          role="alert"
          style={{ position: 'fixed', top: '80px', right: '20px', zIndex: 9999 }}
        >
          {message}
          <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
        </div>
      )}

      <div className="row g-4">
        <div className="col-md-3 border-end pe-3">
          <div className="list-group">
            <button className="list-group-item list-group-item-action active">
              Abonnements
            </button>
          </div>
        </div>

        <div className="col-md-9">
          <h2 className="mb-4">📊 Gestion des abonnements</h2>

          {subscriptions.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Utilisateur</th>
                    <th>Plan</th>
                    <th>Dernière mise à jour</th>
                  </tr>
                </thead>
                <tbody>
                  {subscriptions.map((sub, idx) => (
                    <tr key={idx}>
                      <td>{sub.username}</td>
                      <td><span className="badge bg-info text-dark">{sub.plan}</span></td>
                      <td>{new Date(sub.updated_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-muted">Aucun abonnement trouvé.</p>
          )}
        </div>
      </div>
    </div>
  );
}
